import { render, staticRenderFns } from "./PedidoDetalle.vue?vue&type=template&id=698c80a2"
import script from "./PedidoDetalle.vue?vue&type=script&lang=js"
export * from "./PedidoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports